import { Reducer } from "redux";
import { ConfigTypes } from "./types";

export interface ConfigState{
    filesBaseUrl: string;
    filesBasePath: string;
    //filesSavePath: string;
}
const initialConfigState: ConfigState = {
    filesBaseUrl: '',
    filesBasePath: ''
    //, filesSavePath: ''
  };
  
  const ConfigReducer: Reducer<ConfigState> = (state = initialConfigState, action: any) => {
    switch (action.type) {
     case ConfigTypes.SET_CONFIG: {
      return { ...state, ...action.data };
     }
     default:
      return state;
    }
   };
   
   export default ConfigReducer;
  